// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__BDept","content":"styles_content__2dMoE","checkbox":"styles_checkbox__1s0iJ","checkboxLabel":"styles_checkboxLabel__1U2Wm"};